<template>
  <el-container class="realTimeVideo">
    <!--  实时视频视频解析  -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-card-left">
        <h-button type="primary" @click="clickName()">新建</h-button>
        <h-button
          type="primary"
          :disabled="tableCheckks.length === 0"
          @click="ksztClick(1, '', '开始')"
          >开始</h-button
        >
        <h-button
          type="primary"
          :disabled="tableCheckzt.length === 0"
          @click="ksztClick(3, '', '暂停')"
          >暂停</h-button
        >
        <!-- <h-button
          type="primary"
          :disabled="tableChecksd.length === 0"
          @click="shuodingClick(2)"
          >锁定</h-button
        >
        <h-button
          :disabled="tableCheckyx.length === 0"
          type="primary"
          @click="jieshuoClick(2)"
          >解锁</h-button
        > -->
        <h-button
          type="primary"
          :disabled="tableChecksc.length === 0"
          @click="delClick(2)"
          >删除</h-button
        >
        <!-- <h-button type="primary">下载导出模板</h-button>
        <h-button type="primary">导入</h-button>
        <el-dropdown style="margin-left: 10px" split-button type="primary">
          导出
          <template #dropdown>
            <el-dropdown-menu placeholder="新建">
              <el-dropdown-item>
                <div style="height: 50px; width: 250px">
                  数据： <el-radio label="1">全部</el-radio>
                  <el-radio label="1">本页</el-radio>
                  <div
                    style="
                      color: rgb(250, 140, 22);
                      font-size: 12px;
                      padding-left: 4px;
                    "
                  >
                    注：导出解析明细任务默认限制为3000条。
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown> -->
        <h-button type="primary" @click="refresh()" style="margin-left: 20px"
          >查询</h-button
        >
      </div>
      <div class="tree-card-right">
        <el-input v-model="tableParams.search" placeholder="任务名称/创建人">
          <template #suffix>
            <div @click="refreshTable">
              <el-icon>
                <Search></Search>
              </el-icon>
            </div>
          </template>
        </el-input>
      </div>
    </el-card>
    <el-card class="tree-card-center">
      <el-form
        ref="formRef"
        :model="tableParams"
        size="small"
        label-position="left"
        :inline="true"
      >
        <el-form-item label="状态" class="btnBackground" prop="status">
          <h-selectcode
            bx="bx"
            type="file_upload_status"
            v-model="tableParams.status"
          ></h-selectcode>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tabs-card">
      <h-table
        ref="tableRef"
        v-model:data="tableData"
        v-model:columns="columns"
        :method="taskslist"
        :params="tableParams"
        @select="hzTableSelect"
        style="height: 100%"
      >
        <template #taskName="{ row }">
          <div class="table-role" @click="clickName(row)">
            <span>{{ row.taskName }}</span>
          </div>
        </template>
        <template #priorityLevel="{ row }">
          <span>{{ row.priorityLevel == 1 ? "紧急" : "常规" }}</span>
        </template>
        <template #createTime="{ row }">
          <span>{{ formatDateHMSSJC(row.createTime) }}</span>
        </template>

        <template #status="{ row }">
          <!-- <span>{{
            row.status < 0
              ? "...删除中"
              : row.status === 0
              ? `等待:${row.detailWaitCount}`
              : row.status === 1
              ? `运行:${row.detailRunningCount}`
              : row.status === 2
              ? `异常:${row.detailExceptionCount}`
              : row.status === 3
              ? `暂停:${row.detailSuspendCount}`
              : `完成:${row.detailDoneCount}`
          }}</span> -->
          <span v-if="row.detailWaitCount > 0">{{
            `等待:${row.detailWaitCount}`
          }}</span>
          <span v-if="row.detailRunningCount > 0">{{
            `运行:${row.detailRunningCount}`
          }}</span>
          <span v-if="row.detailExceptionCount > 0">{{
            `异常:${row.detailExceptionCount}`
          }}</span>
          <span v-if="row.detailSuspendCount > 0">{{
            `暂停:${row.detailSuspendCount}`
          }}</span>
          <span v-if="row.detailDoneCount > 0">{{
            `完成:${row.detailDoneCount}`
          }}</span>
        </template>

        <template #operate="{ row }">
          <h-button
            type="primary"
            size="small"
            @click="ksztClick(1, row, '开始')"
            :disabled="row.status !== '3'"
            v-if="row.status === '3'"
            >开始</h-button
          >
          <h-button
            v-else
            type="primary"
            :disabled="row.status !== '1' && row.status !== '2'"
            size="small"
            @click="ksztClick(3, row, '暂停')"
            >暂停</h-button
          >
          <template v-if="!Number(row.detailDoneCount) > 0">
            <h-button
              v-if="row.lockState === '0'"
              type="primary"
              size="small"
              @click="shuodingClick(1, row)"
              >锁定</h-button
            >
            <h-button
              v-else
              type="primary"
              size="small"
              @click="jieshuoClick(1, row)"
              >解锁</h-button
            >
          </template>
          <h-button
            :disabled="row.status === 1 || row.status < 0"
            type="primary"
            size="small"
            @click="delClick(1, row)"
            >删除</h-button
          >
        </template>
      </h-table>
    </el-card>
    <search-range-dialog
      v-model="searchRangeVisible"
      @submit="userSubmit"
    ></search-range-dialog>
  </el-container>
  <realNewLogoff
    v-if="dialogVisible"
    :rowItem="rowItem"
    :states="states"
    @genxin="refreshTable"
    v-model:visible="dialogVisible"
  ></realNewLogoff>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import searchRangeDialog from "../../carSearch/components/searchRangeDialog.vue";
import { formatDateHMSSJC } from "@/utils/index.js";
import realNewLogoff from "@/views/smartApplication/videoAnalysis/components/realTimeVideo/realNewLogoff.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  taskslist,
  lockstatus,
  tasksstatus,
  batchdelete,
} from "@/api/videoAnalysis/videoAnalysisApi.js";
import { Search } from "@element-plus/icons-vue";
export default defineComponent({
  name: "realTimeVideo",
  components: { searchRangeDialog, Search, realNewLogoff },
  props: {},
  setup(props) {
    const state = reactive({
      dialogVisible: false,
      flag: false,
      rowItem: {},
      states: 1,
      treeCard: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "spaceBetween",
      },
      searchRangeVisible: false,
      tableData: [],
      tableCheckks: [],
      tableCheckzt: [],
      tableChecksc: [],
      tableChecksd: [],
      tableCheckyx: [],
      columns: [
        { type: "selection" },
        { type: "index" },
        {
          label: "任务名称",
          slot: "taskName",
        },
        {
          label: "解析状态",
          slot: "status",
        },
        {
          label: "创建人",
          prop: "creator",
        },
        {
          label: "创建时间",
          slot: "createTime",
        },
        {
          slot: "operate",
          label: "操作",
          width: "300px",
        },
      ],
      tableParams: {
        sourceType: "1",
        taskCreateTime: "",
        taskEndTime: "",
        status: "",
        priorityLevel: "",
        search: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur",
          },
        ],
        region: [
          {
            required: true,
            message: "Please select Activity zone",
            trigger: "change",
          },
        ],
        delivery: [
          {
            required: true,
            message: "Please select Activity zone",
            trigger: "change",
          },
        ],

        type: [
          {
            type: "array",
            required: true,
            message: "Please select at least one activity type",
            trigger: "change",
          },
        ],
      },
    });
    const refData = toRefs(state);
    const tableRef = ref(null);
    // 删除
    const delClick = async (is, item) => {
      ElMessageBox.confirm(
        "此操作将删除解析数据且不可逆，请慎重考虑。",
        "确定要删除选中数据吗？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        async () => {
          const params = {
            ids: "",
            sourceTtype: "1",
          };
          if (is === 1) {
            params.ids = [item.id];
          } else {
            params.ids = state.tableChecksc.map((item) => {
              return item.id;
            });
          }

          const res = await batchdelete(params);
          let msg;
          if (res.data.fail != "[]")
            msg = res.data.fail.split(",")[1].split("=")[1];
          if (!msg) {
            state.tableChecksc = [];
            refreshTable();
            ElMessage({
              type: "success",
              message: "删除成功",
            });
          } else {
            ElMessage({
              type: "warning",
              message: msg,
            });
          }
        },
        () => {}
      );
    };
    // 锁定
    const shuodingClick = async (is, item) => {
      ElMessageBox.confirm(
        "锁定后其他用户将不可以操作该任务，请慎重考虑",
        "确定锁定所选任务吗？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        async () => {
          const params = {
            ids: "",
            lockState: 1,
          };
          if (is === 1) {
            params.ids = [item.id];
          } else {
            params.ids = state.tableChecksd.map((item) => item.id);
          }
          const res = await lockstatus(params);
          let msg;
          if (res.data.fail != "[]")
            msg = res.data.fail.split(",")[1].split("=")[1];
          if (!msg) {
            state.tableChecksd = [];
            refreshTable();
            ElMessage({
              type: "success",
              message: "锁定成功",
            });
          } else {
            ElMessage({
              type: "warning",
              message: msg,
            });
          }
        },
        () => {}
      );
    };
    // 解锁
    const jieshuoClick = async (is, item) => {
      ElMessageBox.confirm(
        "解锁后其他用户将可以操作该任务，请慎重考虑。",
        "确定解锁所选任务吗？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        async () => {
          const params = {
            ids: "",
            lockState: 0,
          };
          if (is === 1) {
            params.ids = [item.id];
          } else {
            params.ids = state.tableCheckyx.map((item) => item.id);
          }
          const res = await lockstatus(params);

          let msg;
          if (res.data.fail != "[]")
            msg = res.data.fail.split(",")[1].split("=")[1];
          if (!msg) {
            state.tableCheckyx = [];
            refreshTable();
            ElMessage({
              type: "success",
              message: "解锁成功",
            });
          } else {
            ElMessage({
              type: "warning",
              message: msg,
            });
          }
        },
        () => {}
      );
    };
    // 1 开始 3 暂停
    const ksztClick = async (is, item, text) => {
      ElMessageBox.confirm(
        `确定${text}所选任务吗？`,
        `确定${text}所选任务吗？`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(
        async () => {
          const params = {
            taskIds: item.id,
            status: is,
            sourceType: 1,
          };
          if (item) {
            params.taskIds = [item.id];
          } else {
            //             tableCheckks
            // tableCheckzt
            if (is === 1) {
              params.taskIds = state.tableCheckks.map((item) => item.id);
            } else {
              params.taskIds = state.tableCheckzt.map((item) => item.id);
            }
          }
          const res = await tasksstatus(params);
          let msg;
          if (res.data.fail != "[]")
            msg = res.data.fail.split(",")[1].split("=")[1];
          if (!msg) {
            state.tableCheckzt = [];
            refreshTable();
            ElMessage({
              type: "success",
              message: text + "成功",
            });
          } else {
            ElMessage({
              type: "warning",
              message: msg,
            });
          }
        },
        () => {}
      );
    };
    const hzTableSelect = (val) => {
      // status (string, optional): 任务状态(小于0-中间态;0-等待;1-运行;2-异常;3-暂停;4-完成)) ,
      state.tableCheckks = val.filter((item) => {
        if (item.status === "3") {
          return item;
        }
      }); // 开始
      state.tableCheckzt = val.filter((item) => {
        if (item.status === "1") {
          return item;
        }
      }); // 暂停

      state.tableChecksc = val.filter((item) => {
        if (item.status === "1" || item.status > 0) {
          return item;
        }
      }); // 删除

      state.tableChecksd = val.filter((item) => {
        if (item.lockState === "0") {
          return item;
        }
      }); // 锁定
      state.tableCheckyx = val.filter((item) => {
        if (!item.detailDoneCount > 0) {
          return item;
        }
      }); // 解锁
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
      setTimeout(() => {
        tableRef.value && tableRef.value.refresh();
      }, 5000);
      state.tableCheckks = [];
      state.tableCheckzt = [];
      state.tableChecksc = [];
      state.tableChecksd = [];
      state.tableCheckyx = [];
    };
    const clickName = (row) => {
      if (row) {
        state.rowItem = row;
        state.states = 3;
      } else {
        state.states = 1;
      }
      state.dialogVisible = true;
      // setTimeout(() => {
      //   dialogOffRef.value && dialogOffRef.value.diles(row);
      // });
    };
    const refresh = () => {
      refreshTable();
    };
    return {
      ...refData,
      clickName,
      formatDateHMSSJC,
      taskslist,
      tableRef,
      delClick,
      jieshuoClick,
      shuodingClick,
      ksztClick,
      hzTableSelect,
      refreshTable,
      refresh,
      // resetForm
    };
  },
});
</script>
<style lang="scss" scoped>
.realTimeVideo {
  position: relative;
  flex-direction: column;
  height: 100%;
  .tree-card {
    height: 10%;
    width: 100%;
    /deep/.el-card__body {
      justify-content: space-between;
    }
    .tree-card-left {
      display: flex;
      align-items: center;
    }
  }
  .tree-card-center {
    height: 10%;
    width: 100%;
    margin-top: 10px;
    .text-center {
      text-align: center;
    }
  }
  .tabs-card {
    flex: 1;
    margin-top: 10px;
  }
}
.table-role {
  color: #294a7c;
  cursor: pointer;
  span {
    border-bottom: 1px solid;
  }
}
</style>
